/**
 * "Generated by Platinum · who · when · what" — the stamp every output a
 * person takes out of Platinum carries on the visual itself (#1650). Matt:
 * hidden metadata alone is lost the moment a slide is copied, so the line is
 * drawn where it is seen.
 *
 * One format, defined once per language and pinned to the same sample by
 * tests: here, goapi/pkg/stamp/stamp.go, and the deck engine in
 * agent-runner/skills/skills/pptx-reports/engine/generate_pptx.py.
 */

export const STAMP_PREFIX = 'Generated by Platinum'
const SEPARATOR = ' · '
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export interface OutputStamp {
  /** The requesting user's email. */
  who?: string
  /** Shown in UTC. */
  when: Date
  /** chatRef(...) or tableRef(...). */
  ref?: string
}

const pad2 = (n: number) => String(n).padStart(2, '0')

/** "7 Oct 2026 17:05 UTC" */
export function stampTime(when: Date): string {
  return `${when.getUTCDate()} ${MONTHS[when.getUTCMonth()]} ${when.getUTCFullYear()} ${pad2(when.getUTCHours())}:${pad2(when.getUTCMinutes())} UTC`
}

/** The visible line. An empty who or ref is left out rather than shown as a gap. */
export function stampLine({ who, when, ref }: OutputStamp): string {
  const parts = [STAMP_PREFIX]
  if (who?.trim()) parts.push(who.trim())
  parts.push(stampTime(when))
  if (ref?.trim()) parts.push(ref.trim())
  return parts.join(SEPARATOR)
}

/** An agent session's output: "chat " and the session id's first 8 characters. */
export function chatRef(sessionId: string): string {
  const id = sessionId.trim()
  return id ? `chat ${id.slice(0, 8)}` : ''
}

/** A Tables export: "<job>/<table path>". */
export function tableRef(job: string, path: string): string {
  const j = job.trim()
  const p = path.trim().replace(/^\/+/, '')
  if (!j) return p
  if (!p) return j
  return `${j}/${p}`
}
